// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueI18n from 'vue-i18n';
import moment from 'moment';
import Notify from 'vue2-notify';
import Datepicker from 'vuejs-datepicker';
import Pagination from 'lb-vue-pagination';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import App from './App';
import router from './router';
import store from './store/index';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Autocomplete from './components/lib/Autocomplete.vue';
import InputValidation from './components/lib/InputValidation';
// import EventCalendar from './components/lib/EventCalendar'
// import lbVueSelect from 'lb-vue-select';
import lbVueSelect from './components/lib/Select';
import '../assets/scss/style.scss';
import SortingColumn from './components/lib/SortingColumn.vue';
import GridPrint from './components/lib/GridPrint.vue';

import wysiwyg from './components/lib/editor';
import 'prismjs';
import 'prismjs/themes/prism.css';

import DateTimePicker from 'vue2-datepicker';
import Loading from './components/lib/Loading.vue';
import FileUpload from './components/lib/FileUpload';
import { SchedulePlugin } from '@syncfusion/ej2-vue-schedule';
import lbVueDateTimePicker from 'lb-vue-datetimepicker';
import Grid from './components/lib/Grid.vue';

library.add(fas);

Vue.mixin({
    methods: {
        getPagination(limit, currentPage, totalCount)
        {
            let pages = limit * currentPage;
            if (pages > totalCount)
            {
                pages = totalCount;
            }
            return `${pages}/${totalCount}`;
        },
    },
});

Vue.prototype.moment = moment;
Vue.use(Notify, { position: 'top-right' });
Vue.$notify.notice = function(data)
{
	if(typeof data == 'object' && typeof data.error != 'undefiend')
	{
		var notice = "";
		if(typeof data.fieldErrors != 'undefined')
		{

			for(var key in data.fieldErrors)
			{
				notice += data.fieldErrors[key]+"<br>";
			}
		}
		else notice = data.notice;

		if(data.error) Vue.$notify.error(notice, {mode: 'html'});
		else Vue.$notify.info(notice, {mode: 'html'});
	}
	else Vue.$notify.info(data, {mode: 'html'});
}

Vue.component('grid', Grid);

Vue.use(SchedulePlugin);
Vue.use(BootstrapVue);
Vue.use(VueI18n);
Vue.use(wysiwyg, {
    hideModules: {
        image: true,
    },
});

// Vue.component('eventcalendar', EventCalendar)
Vue.component('lb-vue-datetimepicker', lbVueDateTimePicker);
Vue.component('loading', Loading);
Vue.component('datepicker', Datepicker);
Vue.component('datetimepicker', DateTimePicker);
Vue.component('icon', FontAwesomeIcon);
Vue.component('autocomplete', Autocomplete);
Vue.component('inputvalidation', InputValidation);
Vue.component('pagination', Pagination);
Vue.component('sortingcolumn', SortingColumn);
Vue.component('lb-vue-select', lbVueSelect);
Vue.component('fileupload', FileUpload);
Vue.component('gridprint', GridPrint);

Vue.config.productionTip = false;
const i18n = new VueI18n({});

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount('#app');
